import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { SubNavigation } from "@common/Navigation/SubNavigation";
import "@features/Payment/css/PaymentPage.scss";
import { PaymentBalance } from "@features/Payment/CurrentBalance/PaymentBalance";
import { PaymentCardList } from "@features/Payment/ManageCards/PaymentCardList";
import { TransactionsHistoryList } from "@features/Payment/TransactionHistory/TransactionsHistoryList";
import { EPaymentIframes } from "@features/Payment/interface/IPayment";
import { useGetAccountDetails } from "@features/AccountDetails/hook/useGetAccountDetails";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { useGetPaymentProvider } from "@features/Payment/hook/useGetPaymentProvider";
import { usePayerDetails } from "@features/Payment/ManageCards/hook/usePayerDetails";
import { Grid, Typography } from "@mui/material";

export const PaymentPage = () => {
    const { t } = useTranslation("navigation");
    const [openedPaymentIframe, setOpenedPaymentIframe] = useState<EPaymentIframes>();
    const { accountDetails, accountDetailsState } = useGetAccountDetails();
    const { isNewPaymentProvider, paymentProviderState } = useGetPaymentProvider(accountDetails?.id);
    const { payerDetails, getPayerDetails, getPayerState } = usePayerDetails({
        setOpenedPaymentIframe,
        accountId: accountDetails?.id,
    });

    const setOpenedIframe = (openedIframe?: EPaymentIframes) => {
        setOpenedPaymentIframe(openedIframe);
    };

    return (
        <Fragment>
            <SubNavigation />
            <div className="container-boxed">
                <Typography align="center" color="secondary" paragraph variant="h1">
                    {t("myPayments")}
                </Typography>
                <HandleErrorAndLoading
                    error={accountDetailsState.error ?? paymentProviderState.error}
                    isLoading={accountDetailsState.isLoading || paymentProviderState.isLoading}
                >
                    {accountDetails && isNewPaymentProvider !== undefined && (
                        <Grid container data-testid="payment-children-grid" direction="column" spacing={4}>
                            <Grid item>
                                <PaymentBalance
                                    accountId={accountDetails.id}
                                    getPayerDetails={getPayerDetails}
                                    isNewPaymentProvider={isNewPaymentProvider}
                                    openedIframe={openedPaymentIframe}
                                    paymentMethodList={payerDetails?.paymentMethodList ?? []}
                                    setOpenedIframe={setOpenedIframe}
                                />
                            </Grid>
                            <Grid item>
                                <PaymentCardList
                                    accountId={accountDetails.id}
                                    getPayerState={getPayerState}
                                    isNewPaymentProvider={isNewPaymentProvider}
                                    openedIframe={openedPaymentIframe}
                                    paymentMethodList={payerDetails?.paymentMethodList ?? []}
                                    setOpenedIframe={setOpenedIframe}
                                    successCallback={getPayerDetails}
                                />
                            </Grid>
                            <Grid className="transaction-history" item>
                                <TransactionsHistoryList accountId={accountDetails.id} />
                            </Grid>
                        </Grid>
                    )}
                </HandleErrorAndLoading>
            </div>
        </Fragment>
    );
};
